if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          content: '.read-more__content',
          button: '.read-more__toggle',
          buttonText: '.btn__text',
        };

        this.classes = {
          isDisabled: 'is-disabled',
          isCollapsed: 'is-collapsed',
        };

        this.toggleClass = this.dataset.toggleClass;
        this.showText = this.dataset.showText;
        this.hideText = this.dataset.hideText;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.buttonEl = this.querySelector(this.selectors.button);
        this.contentEl = this.querySelector(this.selectors.content);

        if (!this.buttonEl || !this.contentEl) {
          return;
        }

        const hasText = this.contentEl.textContent.replace(/\s+/g, '') !== '';

        if (!hasText) {
          this.buttonEl.remove();
          return;
        }

        this.classList.remove(this.classes.isDisabled);
        this.contentEl.classList.remove(this.toggleClass);
        this.contentEl.classList.add(this.toggleClass);

        const isTruncated = this.contentEl.scrollHeight > this.contentEl.clientHeight + 1;

        if (!isTruncated) {
          this.contentEl.classList.remove(this.toggleClass);
          this.buttonEl.remove();
          return;
        }

        this.buttonEl.addEventListener('click', this.onClick.bind(this));
        this.classList.add(this.classes.isCollapsed);
      }

      showMore() {
        this.contentEl.classList.remove(this.toggleClass);
        this.classList.remove(this.classes.isCollapsed);
        const buttonTextEl = this.buttonEl.querySelector(this.selectors.buttonText);
        if (buttonTextEl) {
          buttonTextEl.textContent = this.hideText;
        }
      }

      showLess() {
        this.contentEl.classList.add(this.toggleClass);
        this.classList.add(this.classes.isCollapsed);
        const buttonTextEl = this.buttonEl.querySelector(this.selectors.buttonText);
        if (buttonTextEl) {
          buttonTextEl.textContent = this.showText;
        }
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.contentEl.classList.contains(this.toggleClass)) {
          this.showMore();
        } else {
          this.showLess();
        }
      }
    }
  );
}
